import styled from 'styled-components';
import { blue } from '@bufferapp/ui/style/colors';

export const DragUiContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 0;
  overflow: hidden;
  opacity: 0;

  // the delay is used to prevent accidental on and off glitches while dragging
  transition: opacity 300ms 350ms ease-out;
  &.active {
    height: auto;
    opacity: 1;
    // the delay is missing in here so we get an immediate response on drag on
    transition: opacity 350ms ease-out;
  }
`;

export const DragUi = styled(DragUiContent)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9;
  opacity: 0;
  pointer-events: none;

  h4 {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    color: ${blue};
  }

  svg {
    color: ${blue};
  }
`;
